import { useHomeUrl } from '~/features/navigation/utils/useHomeUrl';
import { BreadcrumbLink } from '~/shared/components/BreadcrumbLink/BreadcrumbLink';
import Link from '~/shared/components/Link/Link';
import { useLogoImage } from '~/shared/components/Logo/hooks/useLogoImage';
import { Logo } from '~/shared/components/Logo/Logo';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import { useCheckoutSteps } from '../../../hooks/useCheckoutSteps';
import styles from '../checkoutLayout.module.css';

export const CheckoutHeader = () => {
	const { translate } = useTranslation();
	const { previousStepUrl } = useCheckoutSteps();
	const {
		data: { header },
	} = useFrame();
	const homeUrl = useHomeUrl(header?.home);
	const { image } = useLogoImage({
		brandNo: 'none',
		color: 'dark',
		global: true,
	});

	return (
		<>
			<header className={styles.header}>
				<BreadcrumbLink
					className={styles.breadcrumbLink}
					url={previousStepUrl || header?.basket?.url || '#'}
					text={translate('navigation.back')}
				/>
				<Link
					href={homeUrl}
					className={styles.checkoutLogo}
				>
					<Logo image={image} />
				</Link>
			</header>
		</>
	);
};
